import {
  Balloon,
  Button,
  CascaderSelect,
  Checkbox,
  Dialog,
  Form,
  Input,
  Message,
  Select,
  Table,
} from '@alifd/next';
import { Box, Typography } from '@mui/material';
import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import BarcodeReader from 'react-barcode-reader';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Form;
const AccountUserList = (props) => {
  const user = useSelector((state) => state.user);
  // 頁面權限設定
  const users = client.service('users');
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const [usersArr, setUsersArr] = useState([]);
  const [usersArrAll, setUsersArrAll] = useState([]);
  const [email, setEmail] = useState('');
  const [auth, setAuth] = useState('');
  const [password, setPassword] = useState('');
  const [userEditIndex, setUserEditIndex] = useState(null);
  const [userActiveIndex, setUserActiveIndex] = useState(null);
  const [userEditDialog, setUserEditDialog] = useState(false);
  const [userActiveDialog, setUserActiveDialog] = useState(false);

  const [barcodeDialog, setBarcodeDialog] = useState(false);
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [rfidDialog, setRfidDialog] = useState(false);
  const [rfidDisplay, setRfidDisplay] = useState('');
  const [curdataIndex, setcurDataIndex] = useState('email');
  const [curorder, setcurOrder] = useState('asc');
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [findMembersArr, setFindMembersArr] = useState([]);
  const [recipient, setRecipient] = useState('');
  const [filter, setFilter] = useState({
    f_password: { $exists: false },
    expireTime: { $exists: false },
  });
  // 取得userGroup name data
  // 找到戶號選單排序
  function householdNumberSort(a, b) {
    return a.householdNumber.localeCompare(b.householdNumber);
  }
  const [userAuthArr, setUserAuthArr] = useState([]);
  // console.log("===auth",auth)
  useEffect(() => {
    const userGroup = client.service('userGroup');
    const result = userGroup.find({}).then((result) => {
      setUserAuthArr(
        result.data.map((item) => {
          return item.name;
        })
      );
    });
    residentAccountNumbers.find({}).then((result) => {
      setResidentAccountNumbersArr(result.data.sort(householdNumberSort));
    });
  }, []);

  useEffect(() => {
    if (user.auth.user.auth === 'superAdmin') {
      setFilter({
        $or: [
          {
            f_password: { $exists: false },
            expireTime: { $exists: false },
          },
          { auth: 'superAdmin' },
        ],
      });
    }
  }, [user.auth.user.auth]);

  // 查詢
  const usersFind = useCallback(
    (para) => {
      return new Promise((resolve, reject) => {
        try {
          users
            .find({
              query: para,
              //   query:  {//過濾掉QRcode建立的使用者 [QR建立會產生f_password＆expireTime] 要加在後端
              //   f_password: { '$exists': false },
              //   expireTime: { '$exists': false }
              // }
            })
            .then((result) => {
              resolve(result && result.data ? result.data : []);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    [users]
  );
  // 新增
  function usersCreate(obj) {
    return new Promise((resolve, reject) => {
      try {
        users.create(obj).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  // 更新
  function usersUpdate(id, obj, params) {
    return new Promise((resolve, reject) => {
      users
        .patch(id, obj, params)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  // 刪除
  function usersRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        users.remove(id).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  const serverUsersUpdate = useCallback(
    (dataIndex, order) => {
      const rdataIndex = dataIndex || curdataIndex;
      const rorder = order || curorder;

      usersFind({ ...filter, order: { $gte: user.auth.user.order } }).then(
        (result) => {
          const sortedArr = result.sort((a, b) => {
            const result = (
              typeof a[rdataIndex] === 'number'
                ? a[rdataIndex].toString()
                : a[rdataIndex]
            ).localeCompare(
              typeof b[rdataIndex] === 'number'
                ? b[rdataIndex].toString()
                : b[rdataIndex]
            );
            return rorder === 'asc'
              ? result > 0
                ? 1
                : -1
              : result > 0
              ? -1
              : 1;
          });

          setUsersArr(sortedArr);

          setUsersArrAll(sortedArr);
        }
      );
    },
    [curdataIndex, curorder, filter, usersFind, user]
  );
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverUsersUpdate(dataIndex, order);
  };

  useEffect(() => {
    serverUsersUpdate();
  }, [serverUsersUpdate]);

  function makeid(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function createNewPassword(record) {
    //  console.log(record)
    Swal.fire({
      title: `信箱:${record.email}\n用戶名:${record.name}\n確認幫此帳號產生新密碼?`,
      text: '重新產生一組新密碼，會取代原密碼，請管理員注意(建議此動作為住戶遺失密碼時操作)',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#BEBEBE',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.isConfirmed) {
        const num = makeid(6);
        axios('/ezcon/api/resetPassword', {
          method: 'POST',
          headers: { authorization: window.localStorage['feathers-jwt'] },
          data: {
            email: record.email,
            password: num,
          },
        })
          .then((res) => {
            console.log('Success:', res);
            if (res.status === 200) {
              Message.success('密碼重設成功');
              Swal.fire('成功!', `此帳號新密碼:${num}`, 'success');
            }
          })
          .catch((error) => {
            console.error('Error', error);
            Message.error('密碼重設失敗');
          });
      }
    });
  }

  function noCreateNewPassword(record) {
    console.log(record.email);
    users
      .find({
        query: {
          email: record.email,
        },
      })
      .then((result) => {
        console.log('result', result.data);
        if (result.data.length > 0) {
          Swal.fire(
            '成功!',
            `此為QR Code 開通之帳號，產生新密碼為(${result.data[0].f_password})，請管理員提供此組密碼給住戶`,
            'warning'
          );
        } else {
          Message.error('找無此帳號');
        }
      })
      .catch((error) => {
        Message.error(error);
      });
  }

  function searchRender(value) {
    // input search filter
    if (value.length > 0) {
      const sortedArr = [...usersArrAll]
        .map((e) => {
          let hasIncludes = false;
          Object.keys(e).forEach((ee) => {
            const val2 = e[ee];
            if (val2.toString().includes(value)) hasIncludes = true;
          });
          if (hasIncludes) return e;
          return false;
        })
        .filter((e) => e !== false);

      setUsersArr([...sortedArr]);
    } else {
      setUsersArr([...usersArrAll]);
    }
  }
  const handleRemoveRFId = async (rfId, record) => {
    const { rfidType, _id, auth } = record;
    const newRfIdType = rfidType.filter((e) => e !== rfId);
    try {
      await client.service('users').patch(_id, { rfidType: newRfIdType, auth });
      Message.success('刪除成功');
      serverUsersUpdate();
    } catch (err) {
      Message.error('刪除失敗');
      console.error(err);
    }
  };
  // 製作戶號選單
  function ParseStringToArrayObject() {
    // 戶號拆解
    const data = residentAccountNumbersArr.map((i) =>
      i.householdNumber.split('-')
    );
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    const newStages = {};
    Stages.forEach((e) => {
      // (e.length==1)newStages[e] = [e];
      if (e.indexOf('-') === -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        // newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    const FinalData = [];
    Object.keys(newStages).forEach((e) => {
      // { A:['A','A-1'],B:['B','B-1','B-1-1']...}
      const childrenObj = {};
      newStages[e].forEach((ee) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childrenObj[ee] = {
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].forEach((ee) => {
        // 底層開始 => 加入到上一層children
        // if(ee.length>=3){
        if (ee.indexOf('-') !== -1) {
          const tempArrChild = ee.split('-');
          // const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childrenObj[ky].children) {
            // 加入到上一層children
            childrenObj[ky].children = [childrenObj[ee]];
          } else {
            childrenObj[ky].children.push(childrenObj[ee]);
            // childrenObj[ky].children.sort((a, b) => {
            //   return a.label - b.label;
            // }); // label小－大
          }
        }
      });
      FinalData.push(childrenObj[Object.keys(childrenObj)[0]]); // 只取最上層(第一比obj)(資料已經都加到第一比)
    });
    return FinalData;
  }

  // useEffect(() => {
  //   if (filter.householdNumber) {
  //     console.log(filter.householdNumber);
  //     console.log(usersArr);
  //     console.log(
  //       usersArr.map(
  //         (item) => item?.householdNumbers === [filter.householdNumber]
  //       )
  //     );
  //     // setUsersArr(

  //     // );
  //   }
  // }, [filter]);
  return (
    <>
      {/* 編輯 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userEditDialog}
        onOk={() => {
          const item = usersArr[userEditIndex];
          item.auth = auth.join(',');

          Swal.fire({
            title: `確定修改(${item.email})帳號?`,
            text: '請確認修改資料!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              usersUpdate(item._id, item)
                .then((res) => {
                  console.log('==users update success:', res);

                  Swal.fire('成功!', '此帳號修改成功', 'success');
                  serverUsersUpdate();
                  // setAuth('');
                  setUserEditDialog(false);
                })
                .catch((error) => {
                  console.log('==users update fail:', error);
                  Message.error(`${error}`);
                  serverUsersUpdate();
                });
            }
          });
        }}
        onCancel={() => {
          // setAuth('');
          serverUsersUpdate();
          setUserEditDialog(false);
        }}
        onClose={() => {
          // setAuth('');
          serverUsersUpdate();
          setUserEditDialog(false);
        }}
      >
        <div>
          <h3>編輯頁面權限設定</h3>
          <Form.Item label="權限設定">
            <Checkbox.Group
              value={auth}
              dataSource={userAuthArr}
              onChange={(value) => {
                setAuth(value);
              }}
            />
          </Form.Item>
        </div>
      </Dialog>

      {/* 開通 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={userActiveDialog}
        onOk={() => {
          const obj = usersArr[userActiveIndex];
          const objLength = Object.keys(obj).length;
          if (barcodeDisplay) obj.barcodeType = barcodeDisplay;
          if (rfidDisplay)
            obj.rfidType = [...(obj?.rfidType || []), rfidDisplay];
          if (!barcodeDisplay && !rfidDisplay) {
            // console.log('errors: 請開通條碼及磁扣',);
            Message.error('請開通條碼及磁扣');
          } else {
            delete obj.password;
            users
              .patch(obj._id, obj, { query: { type: 'judgeCards' } })
              .then((res) => {
                console.log('==residentrActive update success:', res);
                Message.success('開通成功');

                serverUsersUpdate();
                setBarcodeDisplay('');
                setRfidDisplay('');

                setUserActiveDialog(false);
              })
              .catch(async (error) => {
                console.log('==residentActive update fail:', error);
                console.log(error.userInfo);
                const userInfo = error.userInfo[0];
                Message.error(`${error}`);
                const result = await Swal.fire({
                  title: '確定要綁定此用戶?',
                  text: `原本綁定於${error.userInfo[0].householdNumbers[0]}(${
                    userInfo?.keyboardAccount ? '家中屏幕' : userInfo.email
                  })是否要更換綁定${obj.householdNumbers[0]}(${obj.name})`,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                });
                if (result.isConfirmed) {
                  const rfid = userInfo.rfidType;
                  rfid.splice(userInfo.rfidType.indexOf(rfidDisplay), 1);
                  console.log(userInfo);
                  delete userInfo.password;
                  await users.patch(userInfo._id, userInfo, {
                    query: { type: 'judgeCards' },
                  });
                  await users.patch(obj._id, obj, {
                    query: { type: 'judgeCards' },
                  });
                  Message.success('開通成功');
                  serverUsersUpdate();
                  setUserActiveDialog(false);
                }

                serverUsersUpdate();
                setBarcodeDisplay('');
                setRfidDisplay('');
              });
          }
        }}
        onCancel={() => {
          setUserActiveDialog(false);
          setBarcodeDisplay('');
          setRfidDisplay('');
        }}
        onClose={() => {
          setUserActiveDialog(false);
          setBarcodeDisplay('');
          setRfidDisplay('');
        }}
      >
        <h1>請開通用戶磁扣</h1>

        {/* <img
          width={300}
          height={200}
          src="/ezcon/img/Barcode.svg"
          className={styles.bcColorBlue}
          type="cover"
          style={{ border: '1px solid #ccc', margin: '10px' }}
          onClick={() => {
            setBarcodeDialog(true);
          }}
        />
        <div>值:{barcodeDisplay}</div>

        <Dialog
          hasMask
          visible={barcodeDialog}
          footer={false}
          onClose={() => {
            setBarcodeDisplay('');
            setBarcodeDialog(false);
          }}
        >
          <Form>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(data)) {
                  setBarcodeDisplay(data);
                  Message.success('掃描成功');
                  setBarcodeDialog(false);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setBarcodeDialog(true);
                }
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item>
              <Input
                style={{ width: '300px' }}
                placeholder="自行輸入條碼 Enter確認"
                name="barcodeDisplay"
                value={barcodeDisplay}
                onChange={(value) => {
                  setBarcodeDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (regex.test(barcodeDisplay)) {
                    Message.success('掃描成功');
                    setBarcodeDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文');
                    setBarcodeDialog(true);
                  }
                }}
              />
            </Item>
            <br />
            <img
              src="/ezcon/img/Barcode.svg"
              className={styles.bcColorBlue}
              alt="barcode"
              type="cover"
              width={400}
              height={300}
            />

            <h1>請掃描條碼...</h1>
          </Form>
        </Dialog> */}

        <img
          width={400}
          height={300}
          src="/ezcon/img/Rfid.svg"
          className={styles.bcColorBlue}
          type="cover"
          style={{ border: '1px solid #ccc', margin: '10px' }}
          onClick={() => {
            setRfidDialog(true);
          }}
        />
        <div>值:{rfidDisplay}</div>

        <Dialog
          hasMask
          visible={rfidDialog}
          footer={false}
          onClose={() => {
            setRfidDialog(false);
            setRfidDisplay('');
          }}
        >
          <Form>
            <BarcodeReader
              onScan={(data) => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(data)) {
                  setRfidDisplay(data);
                  Message.success('掃描成功');
                  setRfidDialog(false);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setRfidDialog(true);
                }
              }}
              onError={(err) => {
                console.error(err);
              }}
            />
            <Item>
              <Input
                style={{ width: '300px' }}
                placeholder="自行輸入條碼 Enter確認"
                name="rfidDisplay"
                value={rfidDisplay}
                onChange={(value) => {
                  setRfidDisplay(value);
                }}
                onPressEnter={() => {
                  const regex = /^[\d|a-zA-Z]+$/;
                  if (regex.test(rfidDisplay)) {
                    Message.success('掃描成功');
                    setRfidDialog(false);
                  } else {
                    Message.error('掃描失敗，僅能數字和英文');
                    setRfidDialog(true);
                  }
                }}
              />
            </Item>

            <br />
            <img
              src="/ezcon/img/Rfid.svg"
              className={styles.bcColorBlue}
              alt="rfid"
              type="cover"
              width={400}
              height={300}
            />

            <h1>請掃描磁扣/卡片...</h1>
          </Form>
        </Dialog>
      </Dialog>

      {/* filter搜尋 */}
      <div style={{ marginBottom: 10 }}>
        <CascaderSelect
          hasClear
          style={{ width: 200 }}
          placeholder="請選擇戶號"
          dataSource={ParseStringToArrayObject()}
          onChange={(value) => {
            setRecipient('');
            let newFilter = { ...filter };
            if (value) {
              newFilter = {
                ...newFilter,
                householdNumbers: { $in: [value] },
              };
            } else {
              delete newFilter.householdNumbers;
            }
            setFilter(newFilter);
            console.log(newFilter);
            users
              .find({
                query: {
                  ...newFilter,
                  order: { $gte: user.auth.user.order },
                  f_password: { $exists: false },
                  expireTime: { $exists: false },
                  // name: { $in: res.data[0].members }
                },
              })
              .then((res) => {
                console.log('==users find names success:', res.data);
                setUsersArr(res.data);
                setFindMembersArr(
                  res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item._id,
                    };
                  })
                );
              })
              .catch((error) => {
                console.log('==users find names fail:', error);
              });
          }}
        />
        {filter?.householdNumbers && (
          <Select
            hasClear
            style={{ width: 200, marginLeft: 10 }}
            placeholder="請選擇用戶名"
            value={recipient}
            onChange={(value) => {
              console.log(value);
              setRecipient(value);
              let newFilter = { ...filter };
              if (value) {
                newFilter = {
                  ...newFilter,
                  name: value,
                };
              } else {
                delete newFilter.name;
              }
              setFilter(newFilter);
              users
                .find({
                  query: {
                    ...newFilter,
                    f_password: { $exists: false },
                    expireTime: { $exists: false },
                    // name: { $in: res.data[0].members }
                  },
                })
                .then((res) => {
                  setUsersArr(res.data);
                })
                .catch((error) => {
                  console.log('==users find names fail:', error);
                });
            }}
          >
            {findMembersArr.map((item) => {
              return (
                <Select.Option key={item.value} value={item.label}>
                  {item.label}
                </Select.Option>
              );
            })}
          </Select>
        )}

        <Input
          style={{ marginLeft: 10 }}
          placeholder="請輸入磁扣值"
          onPressEnter={(e) => {
            console.log(e.target.value);
            let newFilter = { ...filter };
            if (e.target.value) {
              newFilter = {
                ...newFilter,
                rfidType: { $in: [e.target.value] },
              };
            } else {
              delete newFilter.rfidType;
            }
            setFilter(newFilter);
            console.log(newFilter);
            users
              .find({
                query: {
                  ...newFilter,
                  order: { $gte: user.auth.user.order },
                  f_password: { $exists: false },
                  expireTime: { $exists: false },
                  // name: { $in: res.data[0].members }
                },
              })
              .then((res) => {
                console.log('==users find names success:', res.data);
                setUsersArr(res.data);
              })
              .catch((error) => {
                console.log('==users find names fail:', error);
              });
          }}
        />
        {filter?.householdNumbers && filter?.name && filter?.rfidType && (
          <Button
            style={{ marginLeft: 10 }}
            type="primary"
            onClick={() => {
              console.log(filter);
              Swal.fire({
                title: `確認綁定磁扣至${filter.householdNumbers?.$in[0]}?`,
                text: `磁扣號碼${filter.rfidType.$in[0]}綁定至戶號${filter.householdNumbers.$in[0]}姓名${filter.name}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#BEBEBE',
                confirmButtonText: '確定',
                cancelButtonText: '取消',
              }).then(async (result) => {
                if (result.isConfirmed) {
                  const res = await users.find({
                    query: {
                      householdNumbers: {
                        $in: [filter.householdNumbers?.$in[0]],
                      },
                      name: filter.name,
                      order: { $gte: user.auth.user.order },
                      f_password: { $exists: false },
                      expireTime: { $exists: false },
                    },
                  });
                  await users.update(res.data[0]._id, {
                    ...res.data[0],
                    rfidType: [...res.data[0].rfidType, filter.rfidType.$in[0]],
                  });
                  await Swal.fire('成功!', '磁扣綁定成功!!', 'success');
                  await serverUsersUpdate();
                }
              });
            }}
          >
            綁定
          </Button>
        )}
      </div>

      <Table dataSource={usersArr} onSort={onTableSort}>
        <Table.Column
          sortable
          title="信箱(帳號)"
          dataIndex="email"
          width={150}
          lock="left"
        />
        <Table.Column
          title="戶號"
          width={100}
          cell={(record, index) => {
            return (
              <>
                {usersArr[index].householdNumbers
                  ? usersArr[index].householdNumbers.map((list, index) => {
                      return <p key={index}>{list}</p>;
                    })
                  : ''}
              </>
            );
          }}
        />
        <Table.Column sortable title="用戶名" dataIndex="name" width={150} />
        <Table.Column
          sortable
          title="使用者權限"
          dataIndex="auth"
          width={150}
        />
        <Table.Column title="開通條碼值" dataIndex="barcodeType" width={200} />
        <Table.Column
          title="開通磁扣值"
          dataIndex="rfidType"
          width={200}
          cell={(val, _index, record) => {
            return (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '5px',
                }}
              >
                {Array.isArray(val)
                  ? val.map((rfId) => (
                      <Box
                        key={rfId}
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '5px',
                          alignItems: 'center',
                        }}
                      >
                        <Typography>{rfId}</Typography>
                        <Button
                          warning
                          onClick={() => handleRemoveRFId(rfId, record)}
                        >
                          刪除
                        </Button>
                      </Box>
                    ))
                  : val || ''}
              </Box>
            );
          }}
        />

        <Table.Column
          title="操作"
          width={400}
          lock="right"
          cell={(value, index, record) => {
            // const superAdmin = usersArr.filter(
            //   (item) => item.auth.indexOf('superAdmin') >= 0
            // ).length;
            // const admin = usersArr.filter(
            //   (item) => item.auth.indexOf('admin') >= 0
            // ).length;
            let DeleteStatus = true;
            // if (record.auth === 'superAdmin' && superAdmin <= 1) {

            // }
            // if (record.auth === 'admin' && admin <= 1) {
            //   DeleteStatus = false;
            // }

            return (
              <div className={styles.btn}>
                <Button
                  type="normal"
                  onClick={() => {
                    setAuth(usersArr[index].auth.split(','));
                    setUserEditIndex(index);
                    setUserEditDialog(true);
                  }}
                >
                  編輯權限
                </Button>
                {DeleteStatus && (
                  <Button
                    type="primary"
                    warning
                    disabled={record.auth === 'superAdmin'}
                    onClick={() => {
                      const item = usersArr[index];

                      Swal.fire({
                        title: `確定刪除(${record.email})帳號?`,
                        text: '刪除後將無法復原!!',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#BEBEBE',
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                      }).then((result) => {
                        if (result.isConfirmed) {
                          Swal.fire('刪除!', '此帳號已刪除', 'success');

                          usersRemove(item._id).then(() => {
                            serverUsersUpdate();
                          });
                        }
                      });
                    }}
                  >
                    刪除
                  </Button>
                )}

                <Button
                  type="secondary"
                  onClick={() => {
                    setUserActiveDialog(true);
                    setUserActiveIndex(index);
                  }}
                >
                  新增磁扣值
                </Button>
                {/* {record.email.includes("@") ?
                  <Balloon
                    trigger={
                      <Button type="primary" onClick={() => {

                        createNewPassword(record)
                        // alert(makeid(6))
                      }}>
                        產生新密碼
                    </Button>

                    } closable={false}>
                    重新產生一組新密碼，會取代原先密碼!!
               </Balloon> : <Button type="primary" onClick={() => {

                    noCreateNewPassword(record);
                  }}>
                    產生新密碼
                    </Button>} */}
                <Balloon
                  trigger={
                    <Button
                      type="primary"
                      onClick={() => {
                        createNewPassword(record);
                        // alert(makeid(6))
                      }}
                    >
                      產生新密碼
                    </Button>
                  }
                  closable={false}
                >
                  重新產生一組新密碼，會取代原先密碼!!
                </Balloon>
              </div>
            );
          }}
        />
      </Table>
    </>
  );
};

export default AccountUserList;
